import { node } from "~/util/dom";
import { setFormat } from ".";
import GPSSWitchVisualizer from "./visualizer";
import { _ } from "~/i18n";
import Notifications, { NOTIFICATIONS_TYPE } from "~/util/notifications";

export default class GPSSWitchVisualizerSelect {
	_owner: GPSSWitchVisualizer;

	_dom: {
		input: HTMLInputElement;
		seoPara: HTMLParagraphElement;
		button: HTMLSpanElement;
		copyBtn: HTMLButtonElement;
		formatInfo: HTMLParagraphElement;
	};

	_items: Array<string>;

	_selectIndex = 0;

	_gps: any; // Mapy.GPSSwitch

	constructor(owner: GPSSWitchVisualizer) {
		this._owner = owner;
		this._dom = {
			input: node("input", { type: "text" }),
			seoPara: node("p", { className: "coordinates-para" }),
			button: node("span", { className: "change noprint notranslate", innerHTML: "`" }),
			// @ts-ignore
			copyBtn: node("button", { className: "copy noprint", textContent: _("mymap.share.copy") }),
			formatInfo: node("p", { className: "format-info", textContent: "asasd" }),
		};
		this._dom.input.setAttribute("readonly", "readonly");
		this._dom.button.addEventListener("click", this, false);
		this._dom.copyBtn.addEventListener("click", this, false);
		this._items = [];
		this._selectIndex = 0;
		// @ts-ignore
		this._gps = Mapy.getComponent("gps");

		this._build();
	}

	destroy() {
		this._dom.button.removeEventListener("click", this, false);
		this._dom.input.removeEventListener("focus", this);
	}

	getContainer() {
		const frag = document.createDocumentFragment();

		frag.appendChild(this._dom.input);
		frag.appendChild(this._dom.seoPara);
		frag.appendChild(this._dom.button);
		frag.appendChild(this._dom.copyBtn);
		frag.appendChild(this._dom.formatInfo);

		return frag;
	}

	selectItem(index, formatTrans) {
		this._selectIndex = index;
		this._dom.input.value = this._items[index];
		this._dom.input.setAttribute("value", this._items[index]);
		this._dom.seoPara.textContent = this._items[index];
		this._dom.formatInfo.textContent = formatTrans;
	}

	actualizeItems() {
		const formatCoords = this._owner.getFormatCoords();

		this._items = [];

		for (let index = 0; index < formatCoords.length; index++) {
			this._items.push(formatCoords[index]);
		}
	}

	handleEvent(event: Event) {
		if (event.type === "click") {
			event.preventDefault();
			event.stopPropagation();

			if (event.target === this._dom.button) {
				if (this._selectIndex === this._gps.getFormatsCount() - 1) {
					this._selectIndex = 0;
				} else {
					this._selectIndex++;
				}

				setFormat(this._selectIndex);
			} else if (event.target === this._dom.copyBtn) {
				this._dom.input.focus();
				this._dom.input.select();
				document.execCommand("copy");
				// @ts-ignore
				Notifications.notify({
					// @ts-ignore
					type: NOTIFICATIONS_TYPE.SUCCESS,
					// @ts-ignore
					content: _("module.gps.afterCopy"),
					autohide: true,
					duration: 5000,
				});
			}
		} else if (event.type === "focus") {
			this._dom.input.select();
		}
	}

	_build() {
		for (let index = 0; index < this._gps.getFormatsCount(); index++) {
			this._items.push("");
		}

		this._dom.input.addEventListener("focus", this);
	}
}
